export enum CoverTagType {
    'MOST_POPULAR' = 'MOST_POPULAR',
    'BEST_VALUE' = 'BEST_VALUE',
}
